import { Injectable } from "@angular/core";
import { Observable, of, Subject, BehaviorSubject } from "rxjs";
import { KeyValue } from "@angular/common";

@Injectable({
    providedIn:'root'
})
export class BreadcrumbService{

    subject: BehaviorSubject<KeyValue<number, string>>;

    crumbs:KeyValue<number, string>[] = []; // name and id, eg. {key: -1, value: RSM}

    constructor(){
        this.subject = new BehaviorSubject<KeyValue<number, string>>({key: -1, value: 'RSM'}); //not actually needed anymore, chnage to just Subject 

        this.subject.subscribe(next => {
            this.crumbs.push(next)
        });
    }

}

/* above should be the guiding principle on how you use services */